import { useLocation } from 'react-router-dom';
import CountUp from 'react-countup';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AnimatedScore = ({ score }) => (
    <div>
      <h1 className="score-highlight">
        <CountUp start={0} end={score} duration={7.75} />%
      </h1>
    </div>
  );

const LinkComponent = ({ linkString }) => {
    const links = {
      EN: {'url':'https://findelaesclavitud.org/metodos-de-enganche/enamoramiento/','name': 'Enamoramiento','src':'https://i.imgur.com/N40bd8Z.jpg'},
      TR: {'url':'https://findelaesclavitud.org/metodos-de-enganche/falsas-ofertas-laborales/','name': 'Falsas ofertas laborales','src':'https://i.imgur.com/qn9WTsr.jpg'},
      VJ: {'url':'https://findelaesclavitud.org/metodos-de-enganche/video-juegos/','name': 'VideoJuegos','src':'https://i.imgur.com/YDByhLT.jpg'},
      RS: {'url':'https://findelaesclavitud.org/metodos-de-enganche/redes-sociales/','name': 'Redes Sociales','src':'https://i.imgur.com/YbtABRu.jpg'}
    };
  
    const linkArray = linkString.split(',');
  
    return (
      <div className='button-container'>
        {linkArray.map((linkKey, index) => {
          const linkInfo = links[linkKey];
          return linkInfo ? <><b><a key={index} href={linkInfo.url}> <img className='img-button' src={linkInfo.src} /> </a></b><br /></> : null;
        })}
        <br/>
      </div>
    );
  };

const Result = () => {
    const query = useQuery();
    const riesgo = query.get('riesgo');
    const score = query.get('score');


    //"html": " <h2>{totalScore}%</h2> <br> Tus áreas de riesgo son:<br><br> <b>Enamoramiento</b>  <br> <b>Falsas ofertas laborales </b> <br> <b> VideoJuegos </b> <br> Redes Sociales <b> <br> "
    return <div className="reset-pos">
            <div className="result-container">
            <div className="img-contaienr">
                <div className="letterContainer">
                    <h3 className='res-title'>Tu probabilidad de ser víctima de trata de personas es de: </h3>
                    <AnimatedScore score={score} />
                </div>
            </div>
            <p>Da Click en cada uno de los temas. Aprende cómo prevenir y blindar tu vida y la de los que más amas!</p>
            <LinkComponent linkString={riesgo} />
            <div className='phone-container'>
              <p className='phone-l1'>Si te sientes en peligro o ves a alguien en riesgo puedes llamar a la</p>
              <p className='phone-l2'>Línea Nacional  de denuncia Vs la Trata de Personas del Consejo Ciudadano para la seguridad y la justicia de la CDMX</p>
              <p className='phone-l3'>800 55 33000</p>
            </div>
            <div className='sponsorContainer'>
                <p>Esta proyecto de medición ha sido diseñado por</p>
                <img className='img-sponsor' src='https://i.imgur.com/7wc99uS.png' />
                <p>Con el respaldo de </p>
                <img className='img-sponsor' src='https://i.imgur.com/ZDY6soj.png' />
            </div>
            <div className='landing'>
              <p>Conoce más sobre nuestro trabajo en</p>
              <div className='landing-container'>
                <a href='https://www.facebook.com/FinDeLaEsclavitud'> <img className='img-redes' src='https://i.imgur.com/8QBWAaC.png' /> </a>
                <a href='https://www.instagram.com/findelaesclavitud/'> <img className='img-redes' src='https://i.imgur.com/0p4z9Vx.png' /> </a>
                <a href='https://www.youtube.com/@findelaesclavitud'> <img className='img-redes' src='https://i.imgur.com/JjLu5RS.png' /> </a>
                <a href='https://twitter.com/FinEsclavitud'> <img className='img-redes' src='https://i.imgur.com/po16kqG.png' /> </a>
                <a href='https://findelaesclavitud.org'> <img className='img-redes' src='https://i.imgur.com/NokzCne.png' /> </a>
              </div>
            </div>
            </div>
        </div>
  };
  
  export default Result;